import React, { Component } from 'react';
import { Button, Col, Form  } from 'reactstrap';
import SelectFiltro from '../../comum/components/SelectFiltro';
import InputFiltro from '../../comum/components/InputFiltro';
import CardAtencao from '../../comum/components/CardAtencao';
import { IconeInformacao, Fechar } from '../../comum/components/Icones';
import { inject, observer } from 'mobx-react';
import Card from '../../comum/components/Card';
import lscache from 'lscache';

@inject("store")
@observer
export default class FiltroMeuTeconDashboard extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    componentDidMount () {    
        //
    }


    filtrar = (e) => {
        e.preventDefault();
        this.controller.filtrar();
    }

    handleBlur = (event, e) => {
      this.controller.filtrar();
    }

    handleClienteChange = (event) => {        
        this.controller.setCliente(event);
    }

    render() {
        return (
                <Form onSubmit = {this.filtrar}>
                    <div className={`filtros ${window.innerWidth < 991 ? "mb-1" : ""}`}>
                        <div className={`d-flex align-items-center mb-1`}>                            
                            <SelectFiltro   className="mb-1 mt-0"
                                            titulo="Clientes"
                                            tituloClass="mb-1 px-1"
                                            xl={3} lg={6} md={4} sm={6} xs={12}
                                            itens={this.controller.listaClientes}
                                            valor={this.controller.listaClientesSelecionado}
                                            naoLimpar={false}
                                            itensValor="ClibrsId" itensLabel="Razao"
                                            onChange={(event) => this.handleClienteChange(event)}
                            /> 
                            <Button
                                className="ml-1 mt-3 mb-1 btn-com-bordas-primary btn-filtrar"
                                onClick={() => {this.controller.filtrar()}}
                            >
                                Filtrar
                            </Button>                                    
                        </div>
                    </div>
                </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/meutecon/components/FiltroMeuTeconDashboard.js